import _ from 'lodash';
import { Map } from 'immutable';
import BookmarkConstants from '../constants/BookmarkConstants';
import CollectionConstants from '../constants/CollectionConstants';
import PaginatedStore, { RequestStates } from './PaginatedStore';
import Collection from '../models/Collection';

class CollectionStore extends PaginatedStore {
  static storeName = 'CollectionStore';
  static handlers = {
    [CollectionConstants.FETCH_COLLECTION_START]    : 'fetchEntityStart',
    [CollectionConstants.FETCH_COLLECTION_SUCCESS]  : 'fetchEntitySuccess',
    [CollectionConstants.FETCH_COLLECTION_FAILURE]  : 'fetchEntityFailure',
    [CollectionConstants.LIST_COLLECTIONS_START]    : 'listEntitiesStart',
    [CollectionConstants.LIST_COLLECTIONS_SUCCESS]  : 'listEntitiesSuccess',
    [CollectionConstants.LIST_COLLECTIONS_FAILURE]  : 'listEntitiesFailure',
    [CollectionConstants.SET_CURRENT_COLLECTION]    : 'setCurrentEntity',
    [BookmarkConstants.CREATE_BOOKMARK_SUCCESS]     : 'createBookmarkSuccess',
    [BookmarkConstants.DELETE_BOOKMARK_SUCCESS]     : 'deleteBookmarkSuccess'
  };
  static defaultPagination = { offset: 0, limit: 30 };
  static defaultSorter = { key: 'title', direction: 'desc' };
  static defaultCollectionItemsPagination = { offset: 0, limit: 20 };
  // static defaultCollectionItemsSorter = { key: 'rating', direction: 'desc' };
  static entityModel = Collection;

  constructor(dispatcher) {
    super(dispatcher);

    this.collectionsBySlug = new Map();
    this.collectionPaginationBySlug = new Map();
    this.collectionLoadingBySlug = new Map();
    // this.currentCollectionItemsSorter = this.constructor.defaultCollectionItemsSorter;
  }

  fetchEntityStart(data) {
    this.collectionLoadingBySlug = this.collectionLoadingBySlug.set(data.slug, true);
    super.fetchEntityStart(data.entityId);
  }

  fetchEntitySuccess(data) {
    let collection = data.collection;
    this.collectionLoadingBySlug = this.collectionLoadingBySlug.set(collection.slug, false);
    this.collectionPaginationBySlug = this.collectionPaginationBySlug.set(collection.slug, data.pagination);

    // Merge old items with current if pagination request
    if(data.pagination.offset !== 0) {
      let currentCollection = this.entities.get(collection.id);
      if(currentCollection) {
        collection = collection.set('items', currentCollection.items.push(...collection.items));
      }
    }

    this.collectionsBySlug = this.collectionsBySlug.set(collection.slug, collection);
    super.fetchEntitySuccess(collection);
  }

  listEntitiesSuccess(data) {
    if(!_.isEqual(data.sorter, this.currentSorter) || !_.isEqual(data.filters, this.currentFilters)) {
      return;
    }

    data.entities.forEach((collection) => {
      this.collectionsBySlug = this.collectionsBySlug.set(collection.slug, collection);
    });

    super.listEntitiesSuccess(data);
  }

  createBookmarkSuccess(data) {
    if(!data.collectionId) {return;}
    this._updateInventoryRecordInCollection(data);
    this.emitChange();
  }

  deleteBookmarkSuccess(data) {
    if(!data.collectionId) {return;}
    this._updateInventoryRecordInCollection(data);
    this.emitChange();
  }

  getEntityBySlug(slug) {
    return this.collectionsBySlug.get(slug);
  }

  getCollectionStateBySlug(slug) {
    return {
      collection: this.collectionsBySlug.get(slug),
      pagination: this.collectionPaginationBySlug.get(slug) || this.constructor.defaultCollectionItemsPagination,
      loading: this.collectionLoadingBySlug.get(slug) || false
    };
  }

  _updateInventoryRecordInCollection(data) {
    // TODO: Centralize in InventoryRecordStore?
    let id = data.inventoryRecord.id;
    let collection = this.entities.get(data.collectionId);
    let index = this._findIndexOfCollectionItemByInventoryRecordId(collection, id);
    if(-1 !== index) {
      let updatedCollection = collection.setIn(['items', index, 'inventory_record'], data.inventoryRecord);
      // Update entities
      this.entities = this.entities.set(collection.id, updatedCollection);
      // Update in collectionsBySlug
      this.collectionsBySlug = this.collectionsBySlug.set(collection.slug, updatedCollection);
      // Update if in orderedEntities
      if(this.orderedEntities.get(collection.id)) {
        this.orderedEntities = this.orderedEntities.set(collection.id, updatedCollection);
      }
    }
  }

  _findIndexOfCollectionItemByInventoryRecordId(collection, inventoryRecordId) {
    return collection.get('items').findIndex(item => {
      return item.inventory_record.id === inventoryRecordId;
    });
  }

  dehydrate() {
    return _.extend(super.dehydrate(), {
      collectionPaginationBySlug: this.collectionPaginationBySlug,
      collectionLoadingBySlug: this.collectionLoadingBySlug
    });
  }

  rehydrate(state) {
    super.rehydrate(state);
    this.collectionsBySlug = new Map();
    this.entities.forEach((collection) => {
      this.collectionsBySlug = this.collectionsBySlug.set(collection.slug, collection);
    });
    this.collectionPaginationBySlug = new Map(state.collectionPaginationBySlug);
    this.collectionLoadingBySlug = new Map(state.collectionLoadingBySlug);
  }
}

export default CollectionStore;



// WEBPACK FOOTER //
// banquet/stores/CollectionStore.js